module.exports = __webpack_public_path__ + "static/img/2.602bfcc5.png";